import Info from './forms/Info'
import Scope from './forms/Scope'

type AdminRoleScreen = (props: AdminRoleFormProps) => JSX.Element | null

const SCREENS: { [key in AdminRoleStep]: AdminRoleScreen } = {
  info: Info,
  scope: Scope,
}

export { SCREENS }
